import { render, staticRenderFns } from "./InfraHome.vue?vue&type=template&id=4825e6cf&"
import script from "./InfraHome.vue?vue&type=script&lang=js&"
export * from "./InfraHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports